import React, { useEffect, useRef } from 'react';

import { defineCustomElement } from './rpf-global-nav/rpf-global-nav';
import { RpfOrgNav } from './rpf-org-nav';

defineCustomElement();

const RpfGlobalNav = ({ ...props }) => {
  const rpfGlobalNavRef = useRef(null);

  useEffect(() => {
    const rpfGlobalNav = rpfGlobalNavRef.current;
    const selectLanguageHandler = eventData => {
      eventData.detail.event.preventDefault();
      props.onSelectLanguage(eventData.detail.value);
    };

    const logInHandler = eventData => {
      eventData.detail.event.preventDefault();
      props.onLogIn(eventData.detail.event);
    };

    const signUpHandler = eventData => {
      eventData.detail.event.preventDefault();
      props.onSignUp(eventData.detail.event);
    };

    const logOutHandler = eventData => {
      eventData.detail.event.preventDefault();
      props.onLogOut(eventData.detail.event);
    };

    if (!rpfGlobalNav) {
      return;
    }

    rpfGlobalNav.addEventListener('selectLanguage', selectLanguageHandler);

    rpfGlobalNav.addEventListener('logIn', logInHandler);

    rpfGlobalNav.addEventListener('signUp', signUpHandler);

    rpfGlobalNav.addEventListener('logOut', logOutHandler);



    return () => {
      rpfGlobalNav.removeEventListener('selectLanguage', selectLanguageHandler);

      rpfGlobalNav.removeEventListener('logIn', logInHandler);

      rpfGlobalNav.removeEventListener('signUp', signUpHandler);

      rpfGlobalNav.removeEventListener('logOut', logOutHandler);


    };
  }, [props]);

  const refProps = {
    ...props,
    locales: JSON.stringify(props.locales),
  };

  const { loggedIn, hideAccountDropdown, hideSignUp, hideLogIn, ...otherProps } = refProps;

  const propsInKebabCase = {
    'logged-in': loggedIn,
    'hide-account-dropdown': hideAccountDropdown,
    'hide-sign-up': hideSignUp,
    'hide-log-in': hideLogIn,
     ...otherProps
  };

  return React.createElement('rpf-global-nav', { ref: rpfGlobalNavRef, ...propsInKebabCase });
};

export { RpfGlobalNav, RpfOrgNav };

